(function(){
    'use strict';

    class FeedbackService {
        constructor(InfluencerContactService,
            AnalyticsService,
            CoreCompanyService,
            CoreUserService,
            $q,
            $mdDialog,
            $translate,
            FeedbackRequestDialogService,
            FeedbackShareDialogService,
            VALIDATION_CONSTANTS) {

            this.InfluencerContactService = InfluencerContactService;
            this.AnalyticsService = AnalyticsService;
            this.CoreCompanyService = CoreCompanyService;
            this.CoreUserService = CoreUserService;
            this.$q = $q;
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
            this.shouldValidateForm = false;
            this.FeedbackRequestDialogService = FeedbackRequestDialogService;
            this.FeedbackShareDialogService = FeedbackShareDialogService;
            this.VALIDATION_CONSTANTS = VALIDATION_CONSTANTS;
            this.validCountries = [
                'United States',
                'United Kingdom',
                'Canada',
                'Australia',
                'New Zealand',
                'Germany',
                'Switzerland',
                'Sweden',
                'Denmark',
                'Netherlands',
                'Austria',
                'Finland',
                'Norway',
                'Ireland',
                'Malaysia',
                'Singapore',
                'India',
                'France',
                'Belgium',
                'UAE',
                'South Africa',
                'Kenya',
                'Qatar',
                'Saudi Arabia',
                'Hong Kong SAR China',
                'Liechtenstein',
                'Mexico',
                'Brazil',
                'Mainland China',
                'Puerto Rico',
                'Guam',
                'American Samoa',
                'Micronesia',
                'Marshall Islands',
                'Palau',
                'Northern Mariana Islands',
                'U.S. Virgin Islands',
                'Guadeloupe',
                'Guyana',
                'Reunion',
                'Martinique',
                'Mayotte',
                'Aland Islands',
                'Greenland',
                'Faroe Islands'

            ];
            this.initializeCountries();
            var promises = [];

            promises.push(this.CoreUserService.getCurrent(true));
            promises.push(this.CoreCompanyService.getCurrent(true));

            this.$q.all(promises).then(responses => {
                this.currentUser = responses[0];
                this.currentCompany = responses[1];
            });
        }

        initializeContact(contact) {
            this.contact = contact;
            this.type = 'contact';
        }

        initializeSource(source) {
            this.source = source;
            this.type = 'source';
        }
        initializeMissingSource() {
            this.type = 'missing_source';
        }
        initializeMissingContact() {
            this.type = 'missing_contact';
        }

        initializeCountries() {
            this.countries = [];
            for (let i = 0; i < this.validCountries.length; i++) {
                if (this.validCountries[i] === 'UAE') {
                    this.countries.push({
                        name: this.$translate.instant('icm-search__filter--united-arab-emirates'),
                        value: this.validCountries[i]
                    });
                }
                else {
                    let localizedString = 'icm-search__filter--' + this.validCountries[i].toLowerCase().replace(/ /g, '-');
                    this.countries.push({
                        name: this.$translate.instant(localizedString),
                        value: this.validCountries[i]
                    });
                }
            }
            this.countries =  _.sortBy(this.countries, 'name');
        }

        // starting tracking functions
        trackFeedbackStarted() {
            switch (this.type) {
                case 'source':
                    this.trackSourceFeedbackStarted();
                    break;
                case 'missing_contact':
                    this.trackMissingContactFeedbackStarted();
                    break;
            }
        }

        trackSourceFeedbackStarted() {
            var data = {
                source: 'webapp',
                label: 'icm_source_feedback_started',
                sourceId: this.source.id,
                userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
            };
            this.AnalyticsService.trackFeedbackLoop('started', data);
        }

        trackMissingContactFeedbackStarted() {
            var data = {
                source: 'webapp',
                label: 'icm_missing_contact_feedback_started',
                userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
            };
            this.AnalyticsService.trackFeedbackLoop('started', data);
        }

        FeedbackModalController() {
            this.requestPending = false;
            this.requestSuccess = false;
            this.requestRejected = false;
            this.showContactForm = false;
            this.feedbackType = 'share';
            this.errorMessage = '';
            this.selectedReason = 'incorrect';
            this.feedbackDescription = '';
            this.sourceCountry = '';

            // validation rules to mirror Haven's Scooter API validation
            this.SOURCE_NAME_MAX_CHAR = 255;
            this.EMAIL_REGEX = this.VALIDATION_CONSTANTS.EMAIL_REGEX;
            this.URL_REGEX = this.VALIDATION_CONSTANTS.URL_REGEX;

            this.toggleContactForm = function toggleContactForm() {
                this.showContactForm = (this.selectedReason === 'missingContact');
            };

            this.nextModal = function(){
                this.$mdDialog.hide();
                let miniModalVars = {
                    backToMainModal: this.backToMainModal,
                    $mdDialog: this.$mdDialog,
                    $translate: this.$translate,
                    contactName: this.contactName,
                    nextModal: this.nextModal,
                    feedbackType: this.feedbackType,
                    FeedbackRequestDialogService: this.FeedbackRequestDialogService,
                    FeedbackShareDialogService: this.FeedbackShareDialogService,
                    InfluencerContactService: this.InfluencerContactService,
                    AnalyticsService: this.AnalyticsService,
                    currentCompany: this.currentCompany,
                    currentUser: this.currentUser,
                    contact: this.contact,
                    headerTranslation: this.headerTranslation
                };

                if(this.feedbackType === 'share'){
                    this.FeedbackShareDialogService.showShareDialog(miniModalVars);
                } else if (this.feedbackType === 'request') {
                    this.FeedbackRequestDialogService.showRequestDialog(miniModalVars);
                }
            };

            this.backToMainModal = function(vars) {
                this.$mdDialog.hide();
                let miniModalVars = {
                    InfluencerContactService: this.InfluencerContactService,
                    AnalyticsService: this.AnalyticsService,
                    $mdDialog: this.$mdDialog,
                    $translate: this.$translate,
                    currentUser: this.currentUser,
                    currentCompany: this.currentCompany,
                    contact: this.contact,
                    contactName: this.contactName,
                    countries: this.countries,
                    FeedbackRequestDialogService: this.FeedbackRequestDialogService,
                    FeedbackShareDialogService: this.FeedbackShareDialogService,
                    type: this.type,
                    feedbackType: this.feedbackType,
                    headerTranslation: this.headerTranslation
                };

                this.$mdDialog.show(
                    this.$mdDialog.mwMiniModal({
                        locals: miniModalVars,
                        controller: function(){
                           this.nextModal = vars.nextModal;
                           this.$mdDialog = vars.$mdDialog;
                           this.backToMainModal = vars.backToMainModal;
                        },
                        templateUrl: 'icm-web/views/feedback_modal',
                        controllerAs: '$ctrl'
                    })
                );
            };

            this.okModal = function() {
                if (this.type === 'source' && this.selectedReason === 'missingContact') {
                    if (!this.feedbackForm.$valid) {
                        this.shouldValidateForm = true;
                        this.errorMessage = this.$translate.instant('icm-web__profile-feedback--form-error');
                    } else {
                        this.shouldValidateForm = false;
                        this.submitFeedback();
                    }
                }
                else if (!this.feedbackForm.$valid) {
                    this.shouldValidateForm = true;
                    this.errorMessage = this.$translate.instant('icm-web__profile-feedback--form-error');
                } else {
                    this.shouldValidateForm = false;
                    this.submitFeedback();
                }
            };

            this.submitFeedback = function submitFeedback() {
                var feedbackFunction;
                if (this.type === 'missing_contact') {
                    feedbackFunction = this.CreateContactFeedback;
                } else if(this.type === 'missing_source') {
                    feedbackFunction = this.CreateSourceFeedback;
                }

                var payload = this.getPayload();
                this.requestPending = true;

                feedbackFunction(payload).then(function onSuccess() {
                    this.feedbackSubmissionSuccess();
                }.bind(this)).catch(function onError() {
                    this.feedbackSubmissionError();
                }.bind(this)).finally(function afterAll() {
                    this.trackFeedbackCompleted();
                }.bind(this));
            };

            this.CreateContactFeedback = function CreateContactFeedback(payload) {
                return this.InfluencerContactService.submitContactCreateFeedback(payload);
            }.bind(this);

            this.CreateSourceFeedback = function CreateSourceFeedback(payload) {
                return this.InfluencerContactService.submitSourceCreateFeedback(payload);
            }.bind(this);

            this.feedbackSubmissionError = function feedbackSubmissionError() {
                this.errorMessage = this.$translate.instant('icm-web__profile-feedback--error-text');
                this.requestPending = false;
                this.requestRejected = true;
            }.bind(this);

            this.feedbackSubmissionSuccess = function feedbackSubmissionSuccess() {
                this.requestPending = false;
                this.requestSuccess = true;
            }.bind(this);

            // completed tracking functions
            this.trackFeedbackCompleted = function trackFeedbackCompleted() {
                switch (this.type) {
                    case 'source':
                        this.trackSourceFeedbackCompleted();
                        break;
                    case 'missing_contact':
                        this.trackMissingContactFeedbackCompleted();
                        break;
                }
            };

            this.trackSourceFeedbackCompleted = function trackSourceFeedbackCompleted() {
                var data = {
                        source: 'webapp',
                        label: 'icm_source_feedback_completed',
                        sourceId: this.source.id,
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                    feedbackData = {
                        type: this.selectedReason,
                        description: this.feedbackDescription || 'No description'
                    };
                this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
            }.bind(this);

            this.trackMissingContactFeedbackCompleted = function trackMissingContactFeedbackCompleted() {
                var data = {
                        source: 'webapp',
                        label: 'icm_missing_contact_feedback_completed',
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                    feedbackData = {
                        type: this.selectedReason,
                        description: this.feedbackDescription || 'No description'
                    };
                this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
            }.bind(this);

            // payload functions
            this.getPayload = function getPayload() {
                if (this.type === 'source' || this.type === 'missing_source') {
                    return this.getSourcePayload();
                }
                else if (this.type === 'missing_contact') {
                    return this.getMissingContactPayload();
                }
            };

            this.getSourcePayload = function getSourcePayload() {
                let payload;
            
                payload = {
                    companyId: this.currentCompany._id,
                    userId: this.currentUser._id,
                    companyName: this.currentCompany.name,
                    opportunityId: this.currentCompany.opportunityId,
                    customerEmail: this.currentUser.email,
                    sourceName: this.sourceName,
                    sourceUrl: this.sourceUrl,
                    sourceCountry: this.country,
                    language: this.currentUser.language
                };

                if (this.feedbackDescription.length > 0) {
                    payload.description = this.feedbackDescription;
                }
                return payload;
            };

            this.getMissingContactPayload = function getMissingContactPayload() {
                let payload = {
                    resourceType: 'Contact',

                    firstName: this.firstName,
                    lastName: this.lastName,
                    resourceCountry: this.country,
                    newResourceEmail: this.emailAddress,
                    newResourceSourceName: this.sourceName,

                    // company doing the update
                    companyName: this.currentCompany.name,
                    companyId: this.currentCompany._id,
                    accountId: this.currentCompany.accountId,
                    opportunityId: this.currentCompany.opportunityId,

                    // user doing the update
                    customerEmail: this.currentUser.email,
                    userId: this.currentUser._id,
                    language: this.currentUser.language
                };
                if (this.feedbackDescription.length > 0) {
                    // source of contact
                    payload.description = this.feedbackDescription;
                }
                return payload;
            };
            /* jshint ignore:end */
        }

        showFeedbackModal(name) {
            var _this = this,
                miniModalVars = {
                    InfluencerContactService: _this.InfluencerContactService,
                    AnalyticsService: _this.AnalyticsService,
                    FeedbackRequestDialogService: _this.FeedbackRequestDialogService,
                    FeedbackShareDialogService: _this.FeedbackShareDialogService,
                    VALIDATION_CONSTANTS: _this.VALIDATION_CONSTANTS,
                    $mdDialog: _this.$mdDialog,
                    $translate: _this.$translate,
                    currentUser: _this.currentUser,
                    currentCompany: _this.currentCompany,
                    countries: _this.countries,
                    type: _this.type
                },
                template;

            if (_this.type === 'contact') {
                miniModalVars.contact = _this.contact;
                miniModalVars.contactName = name.firstName + ' ' + ((name.middleName) ? name.middleName + ' ' : '') + name.lastName;
                miniModalVars.headerTranslation = _this.$translate.instant('icm-web__profile-feedback--header',{
                    contactName: miniModalVars.contactName
                });
                    template = 'icm-web/views/feedback_modal';
            } else if (_this.type === 'source') {
                miniModalVars.source = _this.source;
                template = 'icm-web/views/source_feedback_modal';
            } else if (_this.type === 'missing_contact') {
                template = 'icm-web/views/missing_contact_feedback_modal';
            } else if (_this.type === 'missing_source') {
                template = 'icm-web/views/missing_source_feedback_modal';
            }

            _this.trackFeedbackStarted(_this.type);
            _this.$mdDialog.show(
                _this.$mdDialog.mwMiniModal({
                    locals: miniModalVars,
                    controller: _this.FeedbackModalController,
                    templateUrl: template,
                    controllerAs: '$ctrl'
                })
            );
        }
    }

    angular.module('MW.Influencers.FeedbackService', [
            'MW.Framework.InfluencerContactService',
            'MW.Influencers.AnalyticsService',
            'MW.Framework.CoreCompanyService',
            'MW.Framework.CoreUserService',
            'ngMaterial',
            'ngMessages',
            'mwAppComponents',
            'MW.Influencers.FeedbackRequestDialogService',
            'MW.Influencers.FeedbackShareDialogService',
            'MW.Framework.ValidationConstants',
    ])
        .service('FeedbackService', [
            'InfluencerContactService',
            'AnalyticsService',
            'CoreCompanyService',
            'CoreUserService',
            '$q',
            '$mdDialog',
            '$translate',
            'FeedbackRequestDialogService',
            'FeedbackShareDialogService',
            'VALIDATION_CONSTANTS',
            FeedbackService
        ]);

})();